import React from 'react';
import { notificationType } from './../shared_proptypes';

function DestinationPromotionErrorsNotification({ notification }) {
  const buttonConfigs = [{
    url: notification.link,
    label: `Go to Campaign ${notification.advertiserCampaignName} - Main`
  }];
  return (
    <span className="notification-item" data-test-id="notification_template">
      <span className="notification-item__details">
        <div className="notification-dropdown__item-message" data-attribute="item-message">
          {notification.message}
          <ul>
            {notification.errors.map(error => <li key={error.message}>{error.count} failed: {error.message}</li>)}
          </ul>
        </div>
        <span>
          {buttonConfigs.map((button, key) =>
            <a
              href={button.url} className="notification-dropdown__item-button" data-attribute="item-button"
              key={key} target="_blank" rel="noopener noreferrer">
              {button.label}
            </a>
          )}
        </span>
        <div className="notification-item__org">
          <span className="notification-item__org-type" data-attribute="org-type">{"Advertiser"} </span>
          <span className="notification-item__org-name" data-attribute="org-name">{notification.advertiserName}</span>
        </div>
      </span>
    </span>
  );
}

DestinationPromotionErrorsNotification.propTypes = {
  notification: notificationType().isRequired
};

export default DestinationPromotionErrorsNotification;
